// extracted by mini-css-extract-plugin
export var singleImage = "style-mod--single-image--bbf6c";
export var singleImageSection = "style-mod--single-image-section--9f86e";
export var singleImageTitle = "style-mod--single-image-title--7651d";